import { DateInputType, TimeHelper } from "@nf/common";

export const getExpirationDate = (expirationDate: DateInputType) => {
  return TimeHelper.format(expirationDate, "DD. MMMM YYYY").toLowerCase();
};
